import cx from 'classnames';
import i18next from 'i18next';

import { updateSideSelection } from 'actions/placeorder';
import { SIDE } from 'constants/enums';
import { isEmpty } from 'helpers/utils';
import { l2BestBidsSelector } from 'selectors';
import {
  enabledPortfolioAssetsSelector,
  userMarginModeSelector,
} from 'selectors/otherSelectors';
import { orderSubmitStatusSelector } from 'selectors/placeOrderSelector';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import { EnabledPFs, getWarningMessage } from '../MarginTypeWarning/util';
import styles from './ChartScreen.module.scss';

const shortLabel = i18next.t('trading:short');

const BestBid = () => {
  const bestBid = useAppSelector(l2BestBidsSelector);
  return <div data-palette="BestBid">{bestBid}</div>;
};

const SellButton = ({ disabled }: { disabled: boolean }) => {
  const dispatch = useAppDispatch();
  const orderSubmitStatus = useAppSelector(orderSubmitStatusSelector);
  const userMarginMode = useAppSelector(userMarginModeSelector);
  const selectedProduct = useAppSelector(selectedProductSelector);
  const enabledPfs = useAppSelector(enabledPortfolioAssetsSelector) as EnabledPFs;

  const warningMsg = getWarningMessage({
    marginMode: userMarginMode as string,
    selectedProduct: selectedProduct || {},
    enabledPfs,
  });

  const handleClick = () => {
    dispatch(updateSideSelection(SIDE.SELL));
  };

  return (
    (<button
      type="submit"
      data-testid="chart-short-button"
      className={cx('naked btn', styles.sellButton, styles.buttonsCommonStyles)}
      onClick={handleClick}
      disabled={disabled || orderSubmitStatus === 'loading' || !isEmpty(warningMsg)}
      data-palette="SellButton">
      <div>{shortLabel}</div>
      <BestBid />
    </button>)
  );
};

export default SellButton;
